import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CategoryMapperService {
  getCategory(styleId: string): string {
    if (!styleId) {
      return;
    }
    let category = '';
    switch (
      styleId
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    ) {
      case 'activities':
      case 'manipulativa':
      case 'investigacion':
      case 'estrategia_pensamiento':
      case 'calculo_mental':
      case 'juego_demostracion':
      case 'mapa_mental':
      case 'oxigeno':
      case 'reto':
      case 'rutina_pensamiento':
      case 'pbl':
      case 'portfolio':
        category = Category.ACTIVIDADES;
        break;
      case 'exercises':
      case 'ejercicio':
      case 'ejercicios_libro':
      case 'campo base':
      case 'descargables':
        category = Category.EJERCICIOS;
        break;
      case 'porfolio':
      case 'ponte_a_prueba':
      case 'tests':
        category = Category.AUTOEVALUACION;
        break;
      case 'resources':
      case 'master_class':
      case 'video_actividad':
      case 'recurso_teorico':
        category = Category.RECURSOS;
        break;
      case 'self-assessment':
      case 'prueba':
      case 'autoevaluacion':
        category = Category.PRUEBAS;
    }
    return category;
  }

  getZeroCategoryStyle(style: string, isHidden: boolean, isTeacher: boolean): string {
    if (!isTeacher && isHidden) {
      return 'disabled';
    }
    if (!style) {
      return;
    }
    let categoryStyle = '';
    switch (
      style
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    ) {
      case 'rutina_pensamiento':
      case 'manipulativa':
      case 'investigacion':
      case 'juego_demostracion':
      case 'mapa_mental':
      case 'oxigeno':
      case 'estrategia_pensamiento':
      case 'calculo_mental':
      case 'reto':
      case 'pbl':
      case 'portfolio':
        categoryStyle = 'actividades';
        break;
      case 'exercises':
      case 'ejercicio':
      case 'ejercicios_libro':
      case 'campo base':
      case 'descargables':
        categoryStyle = 'ejercicios';
        break;
      case 'resources':
      case 'master_class':
      case 'video_actividad':
      case 'recurso_teorico':
        categoryStyle = 'recursos';
        break;
      case 'ponte_a_prueba':
      case 'porfolio':
        categoryStyle = 'autoevaluacion';
        break;
      case 'autoevaluacion':
      case 'prueba':
        categoryStyle = 'pruebas';
    }
    return categoryStyle;
  }

  getIcon(styleId: string): string {
    let icon = '';
    switch (styleId) {
      case 'ejercicios_libro':
      case 'prueba':
        icon = 'download';
        break;
      case 'video_actividad':
        icon = 'play';
    }
    return icon;
  }

  getStretchCategory(stretchId: string): string {
    let category = '';
    switch (stretchId) {
      case 'numeros_operaciones':
      case 'sucesiones_progresiones':
      case 'numeros_algebra':
      case 'algebra':
      case 'proporcionalidad':
      case 'introduccion_algebra':
        category = StretchCategory.NUMEROS_ALGEBRA;
        break;
      case 'figuras_planas':
      case 'cuerpos_geometricos':
      case 'geometria_analitica':
      case 'figuras_cuerpo_geometrico':
      case 'geometria_plano':
        category = StretchCategory.GEOMETRIA;
        break;
      case 'funciones':
      case 'funciones_graficas':
        category = StretchCategory.FUNCIONES;
        break;
      case 'organizacion_datos':
        category = StretchCategory.ESTADISTICA;
        break;
      case 'combinatoria':
      case 'azar_probabilidad':
        category = StretchCategory.PROBABILIDAD;
        break;
      case 'numeric':
        category = StretchCategory.NUMERIC;
        break;
      case 'measurement':
        category = StretchCategory.MEASUREMENT;
        break;
      case 'spatial':
        category = StretchCategory.SPATIAL;
        break;
      case 'algebraic':
        category = StretchCategory.ALGEBRAIC;
        break;
      case 'stochastic':
        category = StretchCategory.STOCHASTIC;
        break;
      case 'extra':
        category = StretchCategory.EXTRA;
        break;

      default:
        category = StretchCategory.OTHERS;
    }
    return category;
  }
}

export enum Category {
  ACTIVIDADES = 'actividades',
  EJERCICIOS = 'ejercicios',
  AUTOEVALUACION = 'autoevaluacion',
  RECURSOS = 'recursos',
  PRUEBAS = 'pruebas',
}
export enum StretchCategory {
  NUMEROS_ALGEBRA = 'numeros_algebra',
  GEOMETRIA = 'geometria',
  FUNCIONES = 'funciones',
  ESTADISTICA = 'estadistica',
  PROBABILIDAD = 'probabilidad',
  OTHERS = 'others',
  NUMERIC = 'numeric',
  MEASUREMENT = 'measurement',
  SPATIAL = 'spatial',
  ALGEBRAIC = 'algebraic',
  STOCHASTIC = 'stochastic',
  EXTRA = 'extra',
}
export enum AutoEvaluacion {
  PORFOLIO = 'PORFOLIO',
  PONTE_A_PRUEBA = 'PONTE_A_PRUEBA',
}
